import { Icon } from "@iconify/react";
import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import {
  getCompanyLogo,
  getJobExperiences,
  getSalaryAmount,
} from "../../../../helpers/common";
import NoLogo from "../../../../assets/images/featured-job/no-logo.png";

const SingleJobApplication = ({ details }) => {
  const jobDetails = details?.job;
  const companyDetails = details?.company;

  console.log("Details*********", details);

  const jobDetailsUrl = `/job/details/${jobDetails?.id}/${jobDetails?.urlSlug}`;

  return (
    <div className={"job-box card mt-4"}>
      <div className="p-4">
        <Row>
          <Col lg={1}>
            <Link to={jobDetailsUrl}>
              <img
                src={getCompanyLogo(companyDetails?.logo)}
                alt={companyDetails?.name}
                className="img-fluid rounded-3 comp-logo"
                // This function runs if the URL returns a 404 or fails to load
                onError={(e) => {
                  e.target.onerror = null; // Prevents infinite loops if NoLogo also fails
                  e.target.src = NoLogo;
                }}
              />
            </Link>
          </Col>

          <Col lg={10}>
            <div className="mt-3 mt-lg-0">
              <h5 className="fs-17 mb-1">
                <Link to={jobDetailsUrl} className="text-dark">
                  {jobDetails?.job_title}
                </Link>{" "}
                <small className="text-muted fw-normal">
                  ({getJobExperiences(jobDetails)} Exp.)
                </small>
              </h5>

              <ul className="list-inline mb-0">
                <li className="list-inline-item">
                  <p className="text-muted fs-14 mb-0">
                    <i className="mdi mdi-office-building text-primary"></i>{" "}
                    {companyDetails?.name || "N/A"}
                  </p>
                </li>

                <li className="list-inline-item">
                  <p className="text-muted fs-14 mb-0">
                    <i className="mdi mdi-map-marker  text-primary"></i>
                    {details?.location?.state || "India"}
                  </p>
                </li>

                <li className="list-inline-item">
                  <p className="text-muted fs-14 mb-0">
                    {getSalaryAmount(jobDetails)}
                  </p>
                </li>
              </ul>
            </div>
          </Col>
        </Row>

        <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
          <div>
            <span
              className={`badge rounded-pill px-3 py-2 fw-semibold ${
                details?.status === "Pending"
                  ? "bg-warning-subtle text-warning border border-warning"
                  : details?.status === "Shortlisted"
                  ? "bg-success-subtle text-success border border-success"
                  : details?.status === "Rejected"
                  ? "bg-danger-subtle text-danger border border-danger"
                  : "bg-secondary-subtle text-secondary border border-secondary"
              }`}
            >
              <i
                className={`me-1 ${
                  details?.status === "Pending"
                    ? "uil uil-clock"
                    : details?.status === "Shortlisted"
                    ? "uil uil-check-circle"
                    : "uil uil-times-circle"
                }`}
              ></i>
              {details?.status}
            </span>
          </div>

    <div className="text-muted small d-flex align-items-center">
  <Icon
    icon="mdi:clock-time-four-outline"
    fontSize={18}
    className="me-1"
  />
  Applied {moment(details?.createdAt).format("DD MMM YYYY")}
</div>
        </div>

        {/* 🎯 Rejection Reason & Date Display for Candidate */}
        {details?.status === "Rejected" && details?.rejectionReason && (
          <div className="bg-danger-subtle rounded-3 p-3 mt-3 border border-danger-subtle">
            <p className="text-danger mb-0" style={{ fontSize: 14 }}>
              <i className="mdi mdi-close-circle-outline me-1"></i>
              <span className="fw-semibold">Rejection Reason:</span>{" "}
              {details.rejectionReason}
              {(details?.updatedAt || details?.createdAt) && (
                <span className="float-end text-muted fs-12">
                  <i className="mdi mdi-calendar-outline me-1"></i>
                  {new Date(details.updatedAt || details.createdAt).toLocaleDateString("en-IN", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}
                </span>
              )}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SingleJobApplication;